import { ImageIcon } from './ImageIcon';

/**
 * author: Google
 * id 3238BA72-FEE8-4C90-A440-AD701359A7BC
 * name image
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/image.svg
 * tags
 */
export const InsertPhotoIcon = ImageIcon;
export default InsertPhotoIcon